import z from "zod";
import { pushGtmEvent } from "./utils";

export const emailRegistrationEventPayloadSchema = z.object({
  event: z.literal("email_registration"),
  data: z.object({
    email: z.string(),
  }),
});

export function emailRegistrationEvent(email?: string) {
  if (typeof window === "undefined") {
    return;
  }

  if (!email) {
    return;
  }

  try {
    const payload = emailRegistrationEventPayloadSchema.parse({
      event: "email_registration",
      data: {
        email,
      },
    });

    pushGtmEvent(payload);
  } catch {}
}
